import { useQuery } from '@tanstack/react-query'
import { ApiError, api } from '@/api/client'
import type { PositionsResponse } from '@/api/types'

/**
 * usePositions polls /api/admin/positions every 10s. 503 (KIS not configured)
 * is captured as `notConfigured: true` so the page can render the banner
 * without forcing the call to retry indefinitely.
 */
export function usePositions() {
  const q = useQuery<{ data: PositionsResponse | null; notConfigured: boolean }>({
    queryKey: ['positions'],
    queryFn: async () => {
      try {
        const data = await api.positions()
        return { data, notConfigured: false }
      } catch (err) {
        if (err instanceof ApiError && err.status === 503) {
          return { data: null, notConfigured: true }
        }
        throw err
      }
    },
    refetchInterval: 10_000,
  })
  return q
}
